var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Lien(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 13 13 C 6.9424416 13 2 17.942442 2 24 C 2 30.057558 6.9424416 35 13 35 L 17.5 35 A 1.50015 1.50015 0 1 0 17.5 32 L 13 32 C 8.5635584 32 5 28.436442 5 24 C 5 19.563558 8.5635584 16 13 16 L 17.5 16 A 1.50015 1.50015 0 1 0 17.5 13 L 13 13 z M 30.5 13 A 1.50015 1.50015 0 1 0 30.5 16 L 35 16 C 39.436442 16 43 19.563558 43 24 C 43 28.436442 39.436442 32 35 32 L 30.5 32 A 1.50015 1.50015 0 1 0 30.5 35 L 35 35 C 41.057558 35 46 30.057558 46 24 C 46 17.942442 41.057558 13 35 13 L 30.5 13 z M 11.5 22.5 A 1.50015 1.50015 0 1 0 11.5 25.5 L 36.5 25.5 A 1.50015 1.50015 0 1 0 36.5 22.5 L 11.5 22.5 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Lien);
export default __webpack_public_path__ + "static/media/icons8-lien.01d26a8f59cafbe629599c3cdd8c0b0b.svg";
export { ForwardRef as ReactComponent };